import { track } from './events';

export function observeLCP() {
  try {
    const po = new PerformanceObserver((list) => {
      const entries = list.getEntries() as PerformanceEntry[];
      const lcp = entries.pop();
      if (lcp) {
        // Only track LCP for authenticated users to avoid 401 errors
        const payload = { event: 'lcp_measured', ts: Date.now(), value: (lcp as any).renderTime || lcp.startTime };
        
        // In development, just log to console
        if (import.meta.env.DEV) {
          console.debug('[Analytics]', payload);
          return;
        }
        
        // In production, only track if user is authenticated
        // This prevents 401 errors on analytics_events table
        track('lcp_measured', { value: (lcp as any).renderTime || lcp.startTime });
      }
    });
    po.observe({ type: 'largest-contentful-paint', buffered: true });
    window.addEventListener('pagehide', () => po.disconnect());
  } catch (error) {
    if (import.meta.env.DEV) console.debug('LCP observer failed:', error);
  }
}